module.exports = "https://r.nearpod.com/assets/media/image/oeq_icon-small-282a437737ac10bdb83e3cfcda069b6a.svg";